import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Payment } from "../../OrderMFE/Payment/types/payment";

export interface PaymentState {
  paymentList: Payment[];
  paymentDetail?: Payment;
}

const initialState: PaymentState = {
  paymentList: [],
  paymentDetail: undefined
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentList: (state, action: PayloadAction<Payment[]>) => {
      state.paymentList = action.payload;
    },
    setPaymentDetail: (state, action: PayloadAction<Payment>) => {
      state.paymentDetail = action.payload;
    },
    resetPaymentDetail: (state) => {
      state.paymentDetail = undefined;
    },
    addPayment: (state, action: PayloadAction<Payment>) => {
      state.paymentList.push(action.payload);
    }
  }
});

export const {
  setPaymentList,
  setPaymentDetail,
  resetPaymentDetail,
  addPayment
} = paymentSlice.actions;

export default paymentSlice.reducer;
